import type { PropsWithChildren } from 'react'
import { createContext } from 'react'
import { useExternalModelHelpers } from 'src/services/helpers/model'
import { createCtx } from 'src/utils/contextState'

export const [ModelUploadContext, ModelUploadContextProvider] = createCtx<{
  /**
   * Current step
   * Navigating to /market/submit/step-[number] greater than this will be redirected back
   */
  step: number
}>({ step: 0 })
ModelUploadContext.displayName = 'ModelUploadContext'

export const ExternalModelImporterContext = createContext(
  {} as ReturnType<typeof useExternalModelHelpers>,
)

// FIXME: This breaks React Fast Refresh
export function ExternalModelImporterProvider(props: PropsWithChildren) {
  const helpers = useExternalModelHelpers()

  return (
    <ExternalModelImporterContext.Provider value={helpers}>
      {props.children}
    </ExternalModelImporterContext.Provider>
  )
}
